/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceCompetitionGame
 */
export interface SurfaceCompetitionGame {
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionGame
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionGame
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCompetitionGame
     */
    thumbnailUrl?: string;
}

/**
 * Check if a given object implements the SurfaceCompetitionGame interface.
 */
export function instanceOfSurfaceCompetitionGame(value: object): value is SurfaceCompetitionGame {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SurfaceCompetitionGameFromJSON(json: any): SurfaceCompetitionGame {
    return SurfaceCompetitionGameFromJSONTyped(json, false);
}

export function SurfaceCompetitionGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceCompetitionGame {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
    };
}

export function SurfaceCompetitionGameToJSON(json: any): SurfaceCompetitionGame {
    return SurfaceCompetitionGameToJSONTyped(json, false);
}

export function SurfaceCompetitionGameToJSONTyped(value?: SurfaceCompetitionGame | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'thumbnailUrl': value['thumbnailUrl'],
    };
}

